import Reveal from "./Reveal";

/**
 * Editorial section heading — Apple Music-style.
 * Uses Instrument Serif for the display title with a script-like feel.
 */
export default function SectionHeading({ eyebrow, title, subtitle, align = "left", tone = "primary" }) {
  const alignCls = align === "center" ? "text-center items-center mx-auto" : "text-left";
  const dot = tone === "accent" ? "bg-accent" : "bg-primary";
  const eyebrowColor = tone === "accent" ? "text-accent" : "text-primary";
  return (
    <div className={`max-w-3xl flex flex-col gap-5 ${alignCls}`}>
      {eyebrow && (
        <Reveal>
          <span className={`inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.26em] font-semibold ${eyebrowColor}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
            {eyebrow}
          </span>
        </Reveal>
      )}
      <Reveal delay={80}>
        <h2 className="font-display font-bold tracking-tight text-4xl md:text-6xl leading-[1.02] text-foreground">
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={160}>
          <p className="text-foreground/60 text-base md:text-lg leading-relaxed max-w-2xl">
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
